<div class="modal modal--single-alert">
  <app-single-alert [alertType]="alertType" [isModal]="true">
    <ng-container copy>
      <h3>To protect your details we'll end your session in:</h3>
      <h3 class="modal__title" *ngIf="sessionTimeLeft$ | async as timeLeft">
        {{ timeLeft?.minutesLeft }} minutes {{ timeLeft?.secondsLeft }} seconds
      </h3>
      <br />
      <h3>
        Please click "Continue" to carry on with your quote or "End my quote" if
        you want to stop your quote with us.
      </h3>
    </ng-container>
    <ng-container buttons>
      <button
        class="dlg-button--primary"
        id="modal-continue"
        aria-label="Continue action and close modal"
        cancelFocus
        dlg-button
        (click)="onClose('continue')"
      >
        Continue
      </button>
      <button
        id="modal-cancel"
        aria-label="Cancel action and close modal"
        cancelFocus
        dlg-button
        (click)="onClose('exit')"
      >
        End my quote
      </button>
    </ng-container>
  </app-single-alert>
</div>
